/**
 * fusionLib JavaScript for widget library.
 *
 * THIS SOFTWARE IS PROVIDED "AS IS" AND WITHOUT ANY EXPRESS OR IMPLIED
 * WARRANTIES, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE.
 *
 * @package fusionLib
 * @copyright Copyright (c) 2013 - 2023 fusionLib. All rights reserved.
 * @link http://fusionlib.com
 */

/**
 * Treeview Widget
 */
jQuery(function() {
	var autoOpenTimer = false, // Timer to auto open nodes
		lib = window.jQuery || window.fusionLib;

	// Enable drag and drop on trees as required
	$('.treeviewwidget').each(function () {
		initTreeview($(this));
	});

	/**
	 * Initialise the tree view widget.
	 *
	 * @param tree The widget element.
	 */
	function initTreeview(tree) {

		if(tree.attr('data-treeview-dndajax-move') != null) {
			tree.parent().makeDragContainer({
				copyFunction: function(marker, element) {
					marker.html('<ol><li class="' + element[0].className + '">' + element.html() + '</li></ol>');
				},
				disableDropOn: 'data-treeview-disableinto',
				disableDragInto: tree.attr('data-treeview-disableinto') === "true"
			})
				.on('draggingStart', function(evt, data) {
					var span = data.dragging.find('span').first();

					if(data.eventTarget.is('b') ||
						span.attr('data-treeview-nodeid') === null ||
						span.attr('data-treeview-draggable') === 'false') {
						data.allowDrag = false;
					}
				})
				.on('draggingOver', function(evt, data) {
					// Kill any outstanding open timers
					if(autoOpenTimer)
						clearTimeout(autoOpenTimer);

					var span =  data.dropTarget.find('span').attr('data-treeview-nodeid');
					if(span === null)
						data.allowPosition = false;
					else {
						// If collapsed node then start a timer to auto open it
						if(data.dropTarget.attr('aria-expanded') === 'false') {
							autoOpenTimer = setTimeout(function() {
								data.dropTarget.find('b').first().trigger('click');
							}, 1000);
						}
					}
				})
				.on('draggingEnd', function(evt, data) {
					if(autoOpenTimer)
						clearTimeout(autoOpenTimer);

					// If dropped on something
					if(data.dropTarget !== null) {

						var parent = $(this),
							tree = parent.find('.treeviewwidget');

						if(tree.attr('data-treeview-dndajax-move')) {
							var mappedPosition,
								moving = data.dragging.find('span'),
								target = data.dropTarget.find('span');

							switch(data.dropPosition) {
								case 'on':
									mappedPosition = 0;
									break;
								case 'before':
									mappedPosition = -1;
									break;
								default:
									mappedPosition = 1;
									break;
							}

							// Show busy
							$('#treeviewDragBusy').addClass('treeviewDragBusyShow');

							// Save the current scroll position
							var scrollPosition = parent.scrollTop();

							// Issue update call
							$.ajax(tree.attr('data-treeview-dndajax-move'), {
								type: 'post',
								timeout: 10000,
								async: true,
								success: function(d) {
									// Set new tree
									parent.html(d.tree);
									restoreOpenClose(parent);

									// Restore the scroll position
									parent.scrollTop(scrollPosition);

									// Make items draggable
									parent.find('li').addClass('dragItem');

									// Trigger event with result data
									parent.trigger('treeviewWidgetMoveEnd', d);

									// Hide busy and show result
									$('#treeviewDragBusy').removeClass('treeviewDragBusyShow');
									$.toastShow(d.success ? 'success' : 'error', d.msg, d.dismiss ? d.dismiss : 'X', null, true);
								},
								error: function() {
									$('#treeviewDragBusy').removeClass('treeviewDragBusyShow');
								},
								data: {
									position: mappedPosition,
									moving: moving.attr('data-treeview-nodeid'),
									target: target.attr('data-treeview-nodeid')
								}
							});
						}
					}
				});
		}
	}

	/**
	 * Expose the ability to initialise the tree view.
	 * @returns this
	 */
	lib.fn.initTreeview = function() {
		initTreeview(this);
		return this;
	};

	$('body')
		.append('<div id="treeviewDragBusy"><div class="treeviewDragBusyIcon"></div></div>');

	/**
	 * Bind a click handler to the treeview open/close
	 */
	$('.treeviewwidgetContainer').on('click', function (e) {
		var el = $(e.target),
			p = el.parent(),
			tree = p;

		// Respond to clicks on b
		if(el.is('b')) {
			// Find the tree name
			while (!tree.hasClass('treeviewwidget'))
				tree = tree.parent();
			tree = 'flWidgetTreeView.' + tree.attr('data-treeviewname');

			var states = JSON.parse(sessionStorage.getItem(tree)) || {};

			if (p.hasClass('open')) {
				p.removeClass('open')
					.attr('aria-expanded', 'false');
				states[p.attr('data-treeviewbranchid')] = false;
			}
			else {
				p.addClass('open')
					.attr('aria-expanded', 'true');
				states[p.attr('data-treeviewbranchid')] = true;
			}

			sessionStorage.setItem(tree, JSON.stringify(states));
		}
	});

	// Restore the save node open/close states
	function restoreOpenClose(parent) {
		var el = parent ? parent.find('.treeviewwidget') : $('.treeviewwidget');

		el.each(function () {
			var root = $(this),
				tree = 'flWidgetTreeView.' + root.attr('data-treeviewname'),
				states = JSON.parse(sessionStorage.getItem(tree)) || {},
				cleaned = {};

			// Find the containers and open those required
			root.find('li').each(function () {
				var el = $(this),
					id = el.attr('data-treeviewbranchid');

				if (states[id]) {
					el.addClass('open')
						.attr('aria-expanded', 'true');
					cleaned[id] = true;
				}
			});

			// Find the active node in the tree and open the nodes above it
			root.find('em').each(function () {
				var p = $(this);

				// Move about active li
				while (!p.hasClass('treeviewwidget') && !p.is('li')) {
					p = p.parent();
				}
				p = p.parent();

				// Open all parents
				while (!p.hasClass('treeviewwidget')) {
					if (p.is('li')) {
						p.addClass('open')
							.attr('aria-expanded', 'true');
						cleaned[p.attr('data-treeviewbranchid')] = true;
					}
					p = p.parent();
				}
			});

			// Store only the open nodes, cleans out removed nodes
			sessionStorage.setItem(tree, JSON.stringify(cleaned));
		});
	}

	// Scroll to active node
	function scrollToActive(parent) {
		var el = parent ? parent : $('.treeviewwidgetContainer');

		el.each(function () {
			var t = $(this),
				h = t.height(),
				a = t.find('em');

			if (a.length) {
				t.scrollTop(((a.offset().top - t.offset().top) + t.scrollTop()) - (h / 2));
			}
		});
	}

	// Restore tress and show the active element
	setTimeout(function() {
		restoreOpenClose();
		scrollToActive();
	}, 10);

	/**
	 * Expose the ability to refocus the tree view.
	 * @returns this
	 */
	lib.fn.refocusTreeview = function() {
		return this.each(function() {
			var el = lib(this);
			restoreOpenClose(el);
			scrollToActive(el);
		});
	};

	/**
	 * Text suggest widgets
	 */

	/**
	 * Scroll the selected item into view.
	 *
	 * @param suggest The suggestion box.
	 */
	function scrollToView(suggest) {
		var el = suggest.find('.selected');
		if(el.length) {
			var t = el.position().top + suggest.scrollTop(),
				h = el.height() + parseInt(el.css('padding-top')) + parseInt(el.css('padding-bottom'));

			// If off top then scroll
			if (t < suggest.scrollTop()) {
				suggest.scrollTop(t);
			}
			// If off bottom then scroll
			else if (t + h > suggest.height() + suggest.scrollTop()) {
				suggest.scrollTop((t - suggest.height()) + h);
			}
		}
	}

	/**
	 * Build the data list from the selection.
	 *
	 * @param e The source selection.
	 * @return The data.
	 */
	function getSuggestData(e) {

		// Get the data attributes & trigger an event
		var data = {};
		if(e.attributes) {
			[].filter.call(e.attributes, function(attr) {
				if(/^data-/.test(attr.name) && attr.name != 'data-id') {
					data[attr.name.replace(/^data-/, '')] = attr.value;
				}
			});
		}

		return data;
	}

	// Attach handlers to all suggest widgets
	$('.suggestwidget').each(function() {

		var name = $(this).attr('data-for'),
			el = $('#' + name),
			suggest = $('#' + name + '-suggestions'),
			key = $('#' + name + '-key'),
			form = el.closest('form'),
			timerID = null,
			selected = 0,
			ignoreMouse = false,
			suggestData = {},
			autoSelFirst = el.attr('data-auto1st') == '1',
			allowDefault = el.attr('data-allow-default') == '1';

		/**
		 * Update the suggestion display.
		 *
		 * @param form The form.
		 * @param el The input element.
		 * @param suggest The suggestion object.
		 * @param name The name of the suggestion element.
		 */
		function updateSuggestions(form, el, suggest, name) {
			var q = el.val();
			if (q.length >= el.attr('data-triggerchars')) {

				// Do the AJAX call
				$.ajax(form.attr('action'), {
					type: 'post',
					timeout: 5000,
					async: true,
					success: function (d) {
						var html = '';
						for (var i = 0; i < d.length; i++) {
							var data = '';
							for(var n in d[i].data) {
								data += ' data-' + n.toLowerCase() + '="' + d[i].data[n] + '"';
							}
							html += '<li data-id="' + (i + 1) + '"' + data +'>' + d[i].label + '</li>'
						}
						if (html.length) {
							html = '<ul>' + html + '</ul>';
							suggest.html(html).removeClass('hide');
							if(autoSelFirst) {
								suggest.find('li').first().addClass('selected');
								selected = suggest.find('li').length ? 1 : 0;
							}
						}
						else {
							suggest.html('').addClass('hide');
						}

						// Trigger update events with matching data
						el.trigger('suggestWidgetUpdate', suggestData = {});
						key.val('');
						suggest.find('li').each(function() {
							if($(this).text().toLowerCase() == el.val().toLowerCase()) {
								el.trigger('suggestWidgetUpdate', suggestData = getSuggestData(this));
								key.val(suggestData.key);
								return false;
							}
						});
					},
					data: {
						suggest_n: name,
						suggest_q: q,
						suggest_extra: el.attr('data-suggest-extra')
					}
				});
			}
			else
				suggest.html('').addClass('hide');
		}

		var startSearch = function() {
			if (timerID)
				clearTimeout(timerID);

			timerID = setTimeout(function () {
				clearTimeout(timerID);
				timerID = null;
				selected = 0;
				suggest.find('li').removeClass('selected');
				updateSuggestions(form, el, suggest, name);
			}, 300);
		};

		// If trigger chars is 0 then open suggestion on click
		if(el.attr('data-triggerchars') === '0') {
			el.on('focus', function(evt) {
				if($(this).val().length === 0) {
					startSearch();
				}
			});
		}

		el
			.on('keydown', function(evt) {
				// If return key pressed and selected item
				if(evt.keyCode == 13 && selected) {
					var s = suggest.find('li.selected');
					if(s.length) {
						el.val(s.text());
						el.trigger('suggestWidgetUpdate', suggestData = getSuggestData(s[0]));
						el.trigger('suggestWidgetSelected', suggestData);
						suggest.addClass('hide');
						selected = 0;
						key.val(suggestData.key);

						// If auto selecting first then send allow default action
						if(!allowDefault)
							evt.preventDefault();
					}
					else
						evt.preventDefault();
				}
				// If not tab
				else if(evt.keyCode != 9) {
					// Trigger update events with matching data
					el.trigger('suggestWidgetUpdate', {});
					key.val('');
					suggest.find('li').each(function() {
						if($(this).text().toLowerCase() == el.val().toLowerCase()) {
							el.trigger('suggestWidgetUpdate', suggestData = getSuggestData(this));
							key.val(suggestData.key);
							return false;
						}
					});
				}
			})
			.on('keyup', function(evt) {

				// A forced up for validation won't have a keycode
				if(evt.keyCode) {

					// If cursor up
					if (evt.keyCode == 38) {
						if (--selected < 1)
							selected = suggest.find('li').length;

						var li = suggest.find('li');
						li.removeClass('selected');
						$(li[selected - 1]).addClass('selected');

						ignoreMouse = true;
						scrollToView(suggest);
						setTimeout(function () {
							ignoreMouse = false;
						}, 100);
					}
					// If cursor down
					else if (evt.keyCode == 40) {
						if (++selected > suggest.find('li').length)
							selected = 1;

						var li = suggest.find('li');
						li.removeClass('selected');
						$(li[selected - 1]).addClass('selected');

						ignoreMouse = true;
						scrollToView(suggest);
						setTimeout(function () {
							ignoreMouse = false;
						}, 100);
					}
					// Else handle suggestions updates
					else if (evt.keyCode != 13) {
						startSearch();
					}
				}
			})
			.on('blur', function() {
				setTimeout(function() {
					suggest.addClass('hide');
				}, 200);
			})
			.on('search', function(evt) {
				el.trigger('suggestWidgetUpdate', suggestData);
			})
			.on('setSuggestData', function(evt, data) {
				suggestData = data;
			});

		suggest
			.on('click', function (evt) {
				el.val($(evt.target).text()).focus();
				el.trigger('suggestWidgetUpdate', suggestData = getSuggestData(evt.target));
				el.trigger('suggestWidgetSelected', suggestData);
				key.val(suggestData.key);
				suggest.addClass('hide');
				el.trigger('keyup'); // Force validation
				evt.preventDefault();
				return false;
			})
			.on('mousemove', function(evt) {
				if(!ignoreMouse) {
					var s = $(evt.target).attr('data-id');
					if (s != selected) {
						var li = suggest.find('li');
						li.removeClass('selected');
						$(li[s - 1]).addClass('selected');
					}
					selected = s;
				}
			});
	});

	/**
	 * Date picker
	 */
	function updateCalendar(el, form, name, delta, currentYMD, textVal) {
		var m = parseInt(el.attr('data-month')),
			y = parseInt(el.attr('data-year')),
			limited = false;

		m += delta;
		if(m == 0) {
			y--;
			m = 12;
		}
		else if(m == 13) {
			y++;
			m = 1;
		}

		var maxM = parseInt(el.attr('data-max-month')),
			maxY = parseInt(el.attr('data-max-year'));

		if(maxM > 0 && maxY > 0) {
			if(y > maxY) {
				m = maxM;
				y = maxY;
				limited = true;
			}
			else if(y == maxY && m > maxM) {
				m = maxM;
				limited = true;
			}
		}

		el.attr('data-month', m);
		el.attr('data-year', y);

		$.ajax(form.attr('action'), {
			type: 'post',
			timeout: 3000,
			async: true,
			success: function (d) {
				el.find('.calendar').html(d.calendar)
				if(textVal.length) {
					el.attr('data-month', d.month);
					el.attr('data-year', d.year);

					el.find('.hour').val(d.hour);
					el.find('.minute').val(d.minute);
					el.find('.ampm').val(d.ampm);
				}
			},
			data: {
				calendar_n: name,
				calendar_m: m,
				calendar_y: y,
				current_ymd: currentYMD,
				text_val: textVal
			}
		});

		return limited || (y === maxY && m === maxM);
	}

	$('.datewidget').each(function() {
		var _this = $(this),
			form = _this.closest('form'),
			name = _this.parent().attr('data-name'),
			currentMnth = parseInt(_this.attr('data-month')),
			currentYr = parseInt(_this.attr('data-year')),
			currentYMD = _this.attr('data-ymd'),
			updateTimeout = null,
			prevMonth = _this.find('.prevMonth'),
			nextMonth = _this.find('.nextMonth');

		prevMonth.on('click', function(evt) {
			updateCalendar(_this, form, name, -1, currentYMD, '');
			nextMonth.show();
			evt.preventDefault();
		});

		nextMonth.on('click', function(evt) {
			if(updateCalendar(_this, form, name, 1, currentYMD, ''))
				nextMonth.hide();
			evt.preventDefault();
		});

		if(updateCalendar(_this, form, name, 1, currentYMD, ''))
			nextMonth.hide();

		function showCal() {
			// Hide all open pickers
			$('.datewidget').hide();

			_this.attr('data-month', currentMnth);
			_this.attr('data-year', currentYr);
			updateCalendar(_this, form, name, 0, currentYMD, $('#' + name).val());
			_this.show();
		}

		_this.closest('.datewidgetWrap').find('.icon').on('click', function() {
			if(_this.css('display') == 'none') {
				$('#' + name).focus();
				showCal();
			}
			else
				_this.hide();
		});

		$('#' + name).on('keyup', function() {
			if(updateTimeout)
				clearTimeout(updateTimeout);
			updateTimeout = setTimeout(function() {
				updateTimeout = null;
				updateCalendar(_this, form, name, 0, currentYMD, $('#' + name).val());
			}, 1000);
		}).on('focus', function() {
			if(_this.css('display') == 'none')
				$('.datewidget').hide();
		});

		// Remove the existing time and update
		function updateTime() {
			if(_this.find('.hour').length) {
				var t = $('#' + name).val(),
					h = _this.find('.hour').val(),
					m = _this.find('.minute').val(),
					a = _this.find('.ampm').val();

				if(m.length < 2)
					m = '0' + m;

				t = t.replace(/\d{1,2}(:\d{2})?\s*(A|P)M/i, '').replace(/^\s+/, '').replace(/\s+$/, '');
				t += ' ' + h + ':' + m + ' ' + a;
				$('#' + name).val(t);
			}
		}

		// Date clicked on the calendar
		_this.find('.calendar').on('click', function(evt) {
			var tgt = $(evt.target);
			if(!tgt.attr('data-ymd'))
				tgt = tgt.parent();

			if(tgt.attr('data-ymd')) {
				currentMnth = parseInt(_this.attr('data-month'));
				currentYr = parseInt(_this.attr('data-year'));
				currentYMD = tgt.attr('data-ymd');

				_this.find('td').removeClass('selected');
				tgt.addClass('selected');
				$('#' + name).val(tgt.attr('data-human'));

				updateTime();

				_this.hide();
			}
		});

		// Time changes
		_this.find('.hour').on('change', updateTime);
		_this.find('.minute').on('change', updateTime);
		_this.find('.ampm').on('change', updateTime);
	});

	// Capture click off picker widget
	$(document).on('click', function(e) {
		if(!$(e.target).closest('.datewidgetWrap').length) {
			$('.datewidget').hide();
		}
	});

	/**
	 * Drag and drop file input element.
	 */

	/**
	 * Send one or more files to the server.
	 *
	 * @param widget The widget.
	 * @param input The input element.
	 * @param action The URL to send the files to.
	 * @param name The input element name.
	 * @param files The file list.
	 */
	function sendFiles(widget, input, action, name, files) {

		// Mark as busy
		var data = {
			showBusy: true
		};
		input.trigger('flFileWidgetUploadStart', data);
		if(data.showBusy) {
			widget.addClass('busy');
		}

		// Create form data
		var fd = new FormData();
		for(var i = 0; i < files.length; i++) {
			fd.append(name, files[i]);
		}

		// See if anything needs to append data to the form
		input.trigger('flFileWidgetUploadAppendData', fd);

		$.ajax(action, {
			type: 'post',
			timeout: 60 * 1000, // 1 minute
			async: true,
			success: function(d) {
				if(data.showBusy)
					widget.removeClass('busy');

				input.trigger('flFileWidgetUploadFinished', d);
				$.toastShow(d.success ? 'success' : 'error', d.msg, d.dismiss ? d.dismiss : 'X', null, true);
			},
			// Capture errors
			error: function() {
				input.trigger('flFileWidgetUploadError');
				$.toastShow('error', 'Upload failed', 'X', null, true);
			},
			data: fd,
			processData: false,
			contentType: false
		});
	}

	function ignoreEvent(e) {
		e.preventDefault();
		e.stopPropagation();
	}

	$('.fileuploadwidget').each(function() {
		var widget = $(this),
			input = widget.find('input'),
			id = input.attr('id'),
			name = id + (input.attr('multiple') ? '[]' : ''),
			form = widget.closest('form'),
			isAjax = widget.attr('data-upload-method') == 'ajax';

		// Capture drag and drop
		if(isAjax)
			widget.on('drag dragstart dragend dragover dragenter dragleave drop', ignoreEvent);

		widget.on('dragover dragenter', function() {
				widget.addClass('uploadDragover');
			})
			.on('dragleave dragend', function() {
				widget.removeClass('uploadDragover');
			})
			.on('drop', function(e) {
				widget.removeClass('uploadDragover');
				if(isAjax)
					sendFiles(widget, input, form.attr('action'), name, e.originalEvent.dataTransfer.files);
				else
					widget.find('.clickUploadMsg').html(e.originalEvent.dataTransfer.files[0].name);
			});

		// Capture changes to the file input
		widget.find('input').on('change', function(evt) {
			if(isAjax) {
				if($(this)[0].files[0]) {
					sendFiles(widget, input, form.attr('action'), name, $(this)[0].files);
				}

				// Reset the file name
				$(this).val('');

				evt.preventDefault();
				evt.stopPropagation();
			}
			else
				widget.find('.clickUploadMsg').html($(this)[0].files[0].name);
		});
	});
});
